<script setup lang="ts">
/**
 * Top nav for the redemption app — same wordmark + glyph as the
 * landing page so the visual family is consistent.
 */
</script>

<template>
  <header class="nav">
    <a href="/" class="brand" aria-label="Lime & The Coconut, home">
      <span class="brand-mark" aria-hidden="true">
        <svg viewBox="0 0 48 48" fill="none" role="img">
          <defs>
            <radialGradient id="r-husk" cx="0.35" cy="0.35" r="0.8">
              <stop offset="0%" stop-color="#9a7748" />
              <stop offset="60%" stop-color="#5d3f24" />
              <stop offset="100%" stop-color="#2a1b0e" />
            </radialGradient>
            <linearGradient id="r-flesh" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stop-color="#fffcf6" />
              <stop offset="100%" stop-color="#f1e4ce" />
            </linearGradient>
            <linearGradient id="r-lime" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stop-color="#c7ea7e" />
              <stop offset="100%" stop-color="#5a7f27" />
            </linearGradient>
          </defs>
          <circle cx="24" cy="26" r="18" fill="url(#r-husk)" />
          <circle cx="24" cy="26" r="13" fill="url(#r-flesh)" />
          <path d="M24 26 L38 14 A18 18 0 0 1 40 20 Z" fill="url(#r-lime)" />
          <path
            d="M26 24 L36 14 M28 26 L38 18 M30 28 L40 22"
            stroke="#5a7f27"
            stroke-width="0.8"
            stroke-linecap="round"
            opacity="0.55"
          />
        </svg>
      </span>
      <span class="brand-word">
        <span class="brand-lime">Lime</span>
        <span class="brand-amp">&amp;</span>
        <span class="brand-coco">The&nbsp;Coconut</span>
      </span>
    </a>
    <nav class="nav-links">
      <a class="nav-link" href="/learner/login">Sign in</a>
    </nav>
  </header>
</template>

<style scoped>
.nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.2rem clamp(1.25rem, 5vw, 4rem);
  max-width: 1320px;
  margin: 0 auto;
  width: 100%;
}
.brand {
  display: inline-flex;
  align-items: center;
  gap: 0.7rem;
  color: var(--ink);
  font-family: 'Fraunces', Georgia, serif;
  font-weight: 600;
  font-size: 1.18rem;
  letter-spacing: -0.01em;
  font-variation-settings: 'SOFT' 40, 'opsz' 36;
  text-decoration: none;
}
.brand-mark {
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--coco-50);
  flex: 0 0 auto;
}
.brand-mark svg { width: 32px; height: 32px; }
.brand-word { display: inline-flex; align-items: baseline; gap: 0.35em; }
.brand-lime { color: var(--lime-700); }
.brand-amp  { color: var(--coco-500); font-style: italic; font-weight: 500; }
.brand-coco { color: var(--coco-800); }
.nav-link {
  color: var(--coco-800);
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 999px;
  font-weight: 500;
  font-size: 0.95rem;
  transition: background 120ms var(--ease);
}
.nav-link:hover {
  background: var(--lime-100);
}
</style>
